import React from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

function ErrorBoundary({ fallback, children }) {
	const defaultFallback = <span className="mx-auto text-sm text-ivory">An error occurred, please try again later</span>;

	return <SentryErrorBoundary fallback={fallback || defaultFallback} children={children} onError={handleError} />;
}

function handleError(error) {
	console.error(error);
}

export default ErrorBoundary;
